/* unplugin-vue-components disabled */import { render } from "./input-recorder.vue?vue&type=template&id=7b62623b&scoped=true"
import script from "./input-recorder.vue?vue&type=script&lang=js"
export * from "./input-recorder.vue?vue&type=script&lang=js"

import "./input-recorder.vue?vue&type=style&index=0&id=7b62623b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b62623b"],['__file',"src/components/chat-input/input-recorder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b62623b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b62623b', __exports__)) {
    api.reload('7b62623b', __exports__)
  }
  
  module.hot.accept("./input-recorder.vue?vue&type=template&id=7b62623b&scoped=true", () => {
    api.rerender('7b62623b', render)
  })

}


export default __exports__